'use client';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'next/navigation';
import { useAccount } from '@/frontastic';
import { OrderHistoryPayload } from '@/sdk/composable-commerce/types/payloads/AccountPayloads';
import OrdersHistory from './orderHistory';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../../../ui/customAccordian/customAccordian';
import Loader from '../../../ui/loader';
import { PAYLOAD_QUERY } from '../../constants';
import { transformOrderHistoryData } from '../../utils';

const CustomerOrderHistory = ({ Texts, billingZipCode }: { Texts: any; billingZipCode: string }) => {
  const [orderHistoryData, setOrderHistoryData] = useState<any>();
  const [loading, setLoading] = useState(false);
  const { getOrderHistory } = useAccount();
  const params = useSearchParams();
  const [value, setValue] = useState('');

  useEffect(() => {
    if (value && !orderHistoryData) {
      fetchOrderHistoryAndTransform();
    }
  }, [value]);

  const fetchOrderHistoryAndTransform = async () => {
    setLoading(true);
    const payload = {
      divisionCode: params.get(PAYLOAD_QUERY.DIVISION_CODE),
      omsCustomerId: params.get(PAYLOAD_QUERY.OMS_CUSTOMER_ID),
    } as OrderHistoryPayload;
    const orderHistoryData = await getOrderHistory(payload);
    if (orderHistoryData) {
      const transformedData = transformOrderHistoryData(orderHistoryData);
      setOrderHistoryData(transformedData);
    }
    setLoading(false);
  };

  return (
    <Accordion
      type="single"
      collapsible
      className="w-full rounded-md border border-foggyGray px-5 py-1 shadow-lg"
      onValueChange={setValue}
    >
      <AccordionItem value="openNote" className="border-none">
        <AccordionTrigger className="flex text-lg font-bold hover:no-underline">
          <p className="mr-auto">{Texts.orderHistory}</p>
        </AccordionTrigger>
        <AccordionContent>
          {loading ? (
            <Loader />
          ) : (
            <OrdersHistory
              orderData={orderHistoryData?.orderData}
              showOrderPagination={orderHistoryData?.showOrderPagination}
              nextOrderDate={orderHistoryData?.nextOrderDate}
              billingZipCode={billingZipCode}
            />
          )}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export default CustomerOrderHistory;
